import { render, staticRenderFns } from "./ClientsDeleteDoc.vue?vue&type=template&id=21ca350c"
import script from "./ClientsDeleteDoc.vue?vue&type=script&lang=js"
export * from "./ClientsDeleteDoc.vue?vue&type=script&lang=js"
import style0 from "./ClientsDeleteDoc.vue?vue&type=style&index=0&id=21ca350c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports